import { createMuiTheme } from '@material-ui/core/styles';
import { green, grey, red } from '@material-ui/core/colors';

const rawTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#1a1a2e',
      main: '#0a0a0f',
      dark: '#050508',
    },
    secondary: {
      light: '#4dc247',
      main: '#16b724',
      dark: '#0e8a1a',
    },
    warning: {
      main: '#ffc071',
      dark: '#ffb25e',
    },
    error: {
      xLight: red[50],
      main: red[500],
      dark: red[700],
    },
    success: {
      xLight: green[50],
      main: green[500],
      dark: green[700],
    },
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontFamilySecondary: "'Inter', 'Segoe UI', sans-serif",
  },
});

const fontHeader = {
  color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontFamily: "'Inter', sans-serif",
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
};

const theme = {
  ...rawTheme,
  palette: {
    ...rawTheme.palette,
    background: {
      ...rawTheme.palette.background,
      default: '#0a0a0f',
      placeholder: grey[200],
    },
  },
  typography: {
    ...rawTheme.typography,
    fontHeader,
    h1: {
      ...rawTheme.typography.h1,
      ...fontHeader,
      letterSpacing: '0.04em',
      fontSize: 56,
      fontWeight: 700,
    },
    h2: {
      ...rawTheme.typography.h2,
      ...fontHeader,
      fontSize: 44,
      fontWeight: 700,
    },
    h3: {
      ...rawTheme.typography.h3,
      ...fontHeader,
      fontSize: 38,
      fontWeight: 600,
    },
    h4: {
      ...rawTheme.typography.h4,
      ...fontHeader,
      fontSize: 32,
      fontWeight: 600,
    },
    h5: {
      ...rawTheme.typography.h5,
      fontSize: 20,
      fontWeight: 400,
      lineHeight: 1.6,
    },
    h6: {
      ...rawTheme.typography.h6,
      ...fontHeader,
      fontSize: 18,
      fontWeight: 500,
    },
    subtitle1: {
      ...rawTheme.typography.subtitle1,
      fontSize: 18,
    },
    body1: {
      ...rawTheme.typography.body2,
      fontWeight: rawTheme.typography.fontWeightRegular,
      fontSize: 16,
      lineHeight: 1.7,
    },
    body2: {
      ...rawTheme.typography.body1,
      fontSize: 14,
      lineHeight: 1.6,
    },
  },
};

export default theme;
